// FVスライダー
document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  var fvSplideEl = document.querySelector('.p-top__fv__splide');

  if (!fvSplideEl) {
    return;
  }

  var slides = fvSplideEl.querySelectorAll('.splide__slide');

  if (slides.length <= 1) {
    return;
  }

  var fvSplide = new Splide(fvSplideEl, {
    type: 'loop',
    arrows: false,
    pagination: false,
    autoplay: true,
    interval: 6000,
    speed: 600,
    pauseOnHover: false,
    pauseOnFocus: false
  });

  var currentEl = fvSplideEl.querySelector('.splide__pagination__current'),
    totalEl = fvSplideEl.querySelector('.splide__pagination__total'),
    prevEl = fvSplideEl.querySelector('.splide__prev'),
    nextEl = fvSplideEl.querySelector('.splide__next');

  function updatePagination(splide) {
    var index = splide.index + 1,
      length = splide.length;

    if (currentEl) {
      currentEl.textContent = ('0' + index).slice(-2);
    }
    if (totalEl) {
      totalEl.textContent = ('0' + length).slice(-2);
    }
  }

  // var progressCircles = fvSplideEl.querySelectorAll('.p-top__fv__progress__circle');

  // function restartProgress() {
  //   Array.from(progressCircles).forEach(function (circle) {
  //     circle.classList.remove('is-animating');
  //     circle.style.transition = 'none'; // 追加: transitionを一旦完全に無効化
  //     void circle.offsetWidth; // reflow強制

  //     requestAnimationFrame(function () {
  //       circle.style.transition = ''; // 追加: transitionを元に戻す(CSS側の指定に委ねる)
  //       circle.classList.add('is-animating');
  //     });
  //   });
  // }

  // fvSplide.on('mounted move', function () {
  //   updatePagination(fvSplide);
  //   restartProgress();
  // });

  if (prevEl) {
    prevEl.addEventListener('click', function () {
      fvSplide.go('<');
    });
  }

  if (nextEl) {
    nextEl.addEventListener('click', function () {
      fvSplide.go('>');
    });
  }

  fvSplide.mount();
});

// topicスライダー
document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  var topicsSection = document.querySelector('.l-top__topics');
  var topicsSplideEl = document.querySelector('.p-top__topics__splide');

  if (!topicsSplideEl) {
    return;
  }

  var prevEl = topicsSection.querySelector('.splide__prev'),
    nextEl = topicsSection.querySelector('.splide__next'),
    gapValue = window.innerWidth <= 760 ? 16 : 33;

  var topicsSplide = new Splide(topicsSplideEl, {
    type: 'loop',
    fixedWidth: true,
    autoplay: false,
    pagination: false,
    arrows: false,
    gap: gapValue
  });

  if (prevEl) {
    prevEl.addEventListener('click', function () {
      topicsSplide.go('<');
    });
  }

  if (nextEl) {
    nextEl.addEventListener('click', function () {
      topicsSplide.go('>');
    });
  }

  topicsSplide.mount();
});

// productバリアント制御
document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  var productItems = document.querySelectorAll('.p-top__product__listitem');

  Array.from(productItems).forEach(function (item) {
    var colorButtons = item.querySelectorAll('.p-top__product__listitem__color'),
      mainImg = item.querySelector('.p-top__product__listitem__mainimg'),
      nameLink = item.querySelector('.p-top__product__listitem__name'),
      imgAreaLink = item.querySelector('.p-top__product__listitem__imgarea');

    Array.from(colorButtons).forEach(function (button) {
      button.addEventListener('click', function () {
        var variantUrl = button.getAttribute('data-variant-url'),
          variantImage = button.getAttribute('data-variant-image');

        Array.from(colorButtons).forEach(function (b) {
          b.classList.remove('is-active');
        });
        button.classList.add('is-active');

        if (mainImg && variantImage) {
          mainImg.setAttribute('src', variantImage);
        }

        if (nameLink && variantUrl) {
          nameLink.setAttribute('href', variantUrl);
        }

        if (imgAreaLink && variantUrl) {
          imgAreaLink.setAttribute('href', variantUrl);
        }
      });
    });
  });

  preloadColorVariantImages();
});

// カラーチップの画像をバックグラウンドで先読みしておく
function preloadColorVariantImages() {
  var colorButtons = document.querySelectorAll('.p-top__product__listitem__color');

  Array.from(colorButtons).forEach(function (button) {
    var variantImage = button.getAttribute('data-variant-image');

    if (variantImage) {
      var img = new Image();
      img.src = variantImage;
    }
  });
}

// awardスライダー
document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  var awardSplideEl = document.querySelector('.p-top__award__splide');

  if (!awardSplideEl) {
    return;
  }

  function initAwardSplide() {
    var track = awardSplideEl.querySelector('.splide__track'),
      list = awardSplideEl.querySelector('.splide__list'),
      slides = list.querySelectorAll('.splide__slide'),
      totalSlidesWidth = 0,
      containerWidth = track.clientWidth,
      viewportWidth = window.innerWidth,
      slideCount = slides.length,
      gapValue = viewportWidth <= 760 ? 9 : 24,
      bufferMultiplier = 6,
      cloneCount;

    if (slideCount === 0) {
      return;
    }

    Array.from(slides).forEach(function (slide) {
      totalSlidesWidth += slide.offsetWidth;
    });

    totalSlidesWidth += gapValue * slideCount;

    if (totalSlidesWidth <= containerWidth) {
      awardSplideEl.classList.add('is-static');
    } else {
      awardSplideEl.classList.add('is-slider');

      cloneCount = Math.ceil(slideCount * bufferMultiplier);

      new Splide(awardSplideEl, {
        type: 'loop',
        drag: false,
        arrows: false,
        pagination: false,
        perPage: 'auto',
        gap: gapValue,
        autoWidth: true,
        clones: cloneCount,
        autoScroll: {
          speed: 1,
          rewind: true,
          pauseOnHover: false,
          pauseOnFocus: false
        }
      }).mount({ AutoScroll: window.splide.Extensions.AutoScroll });
    }

    awardSplideEl.classList.add('is-ready');
  }

  initAwardSplide();
});

// Newsアコーディオン
const ac = document.querySelectorAll(".js-accordion__toggle");
function acToggle() {
  const content = this.nextElementSibling;

  content.classList.toggle("is-open");
  const ac = this;
  ac.classList.toggle('is-open');
}

for (let i = 0; i < ac.length; i++) {
  ac[i].addEventListener("click", acToggle);
}